import { render } from "./FpHeader.vue?vue&type=template&id=5f668f86&lang=pug"
import script from "./FpHeader.vue?vue&type=script&lang=js"
export * from "./FpHeader.vue?vue&type=script&lang=js"

import "./FpHeader.vue?vue&type=style&index=0&id=5f668f86&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__